import { render, staticRenderFns } from "./BuyMembershipStory.vue?vue&type=template&id=11d58a74&"
import script from "./BuyMembershipStory.vue?vue&type=script&lang=ts&"
export * from "./BuyMembershipStory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports